"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _wrapper;

  return {
    wrapper: (_wrapper = {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "column"
    }, _defineProperty(_wrapper, theme.breakpoints.up("sm"), {
      alignItems: "center",
      flexDirection: "row"
    }), _defineProperty(_wrapper, "& div", {
      flex: "unset"
    }), _defineProperty(_wrapper, "& .mco-form-button-wrapper", _defineProperty({
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(1)
    }, theme.breakpoints.up("sm"), {
      marginTop: 0
    })), _wrapper),
    alternativeLogin: {
      cursor: "pointer",
      fontWeight: theme.typography.fontWeightBold
    },
    forgotPassword: {
      cursor: "pointer",
      fontWeight: theme.typography.fontWeightBold
    },
    endIcon: {
      cursor: "pointer",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5)
    }
  };
});
var _default = styles;
exports.default = _default;